import { jsx as _jsx } from "react/jsx-runtime";
import { SmartConfigRouterInstruction } from 'console/smart-config/components/router/instruction';
import { SmartConfigRouterSending } from 'console/smart-config/components/router/sending';
import { RouterDialog } from 'shared/components/dialogs/router';
export const smartConfigRoutes = [
    {
        path: '/smart-config',
        element: _jsx(RouterDialog, { title: "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0430 Wi-Fi" }),
        children: [
            {
                path: 'prepare',
                element: _jsx(SmartConfigRouterInstruction, {}),
            },
            {
                path: 'sending',
                element: _jsx(SmartConfigRouterSending, {}),
            },
        ],
    },
];
